import type { MonetaryAmount } from "../../../../currency/currencyTypes"
import { AnyMeeting } from "../../../../nonAdminUser/reports/MeetingsReceipt/UserMeetingsReceipt"
import { AnyMeetingServiceOrder } from "../../production/meetingService/components/OrderPackageSlip"

type DropdownOrder = AnyMeeting | AnyMeetingServiceOrder

type DropdownOrderExtras = Readonly<
    Partial<{
        amount: MonetaryAmount
        paymentDetails: Readonly<{ method?: string }>
        deliveryDetails: Readonly<{ time?: string }>
        sellerSupplierParty: Readonly<{ name?: string }>
        customer: Readonly<{ email?: string; displayName?: string }>
        organizers: ReadonlyArray<Readonly<{ email?: string; name?: string }>>
        kitchen: Readonly<{ name?: string }>
    }>
>

function asExtras(order: DropdownOrder): DropdownOrderExtras {
    return order as DropdownOrderExtras
}

export function hasOrganizers(order: DropdownOrder) {
    return "organizers" in order
}

export function hasCustomer(order: DropdownOrder) {
    return "customer" in order
}

export function getDeliveryTimeFromOrder(order: DropdownOrder): string | undefined {
    if ("deliveries" in order && order.deliveries?.[0]?.deliveryTime) {
        return order.deliveries[0].deliveryTime
    }
    return asExtras(order).deliveryDetails?.time
}

export function getMonetaryAmountFromOrder(order: DropdownOrder): MonetaryAmount | undefined {
    return asExtras(order).amount
}

export function getPaymentMethodFromOrder(order: DropdownOrder): string | undefined {
    return asExtras(order).paymentDetails?.method
}

export function getCanteenNameFromOrder(order: DropdownOrder): string | undefined {
    const extras = asExtras(order)
    return extras.sellerSupplierParty?.name ?? extras.kitchen?.name
}

export function getCustomerEmailFromOrder(order: DropdownOrder): string | undefined {
    const extras = asExtras(order)
    return extras.customer?.email ?? extras.organizers?.[0]?.email
}

